// utils/firebaseStorage.ts
import { getStorage, ref, getDownloadURL } from "firebase/storage";

export const getStoreLogoUrl = async (storeID: string): Promise<string> => {
  try {
    const storage = getStorage();
    const logoRef = ref(storage, `storeData/${storeID}/logo`);
    const url = await getDownloadURL(logoRef);
    return url;
  } catch (error) {
    console.error("Error generating logo URL:", error);
    return "/default-store-logo.png";
  }
};
